module.exports = __webpack_public_path__ + "static/media/creativ3.9fc88abd.jpg";